import type { MessageData, PaginatedResponse, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { deviceEndpoints, replaceParams } from "@/app/api/endpoints";
import type { CreateDeviceRequest, Device, ListDevicesParams, UpdateDeviceRequest } from "../types";

export const deviceService = {
	async list(params?: ListDevicesParams): Promise<PaginatedResponse<Device>> {
		const response = await apiClient.get<PaginatedResponse<Device>>(deviceEndpoints.list, {
			params,
		});
		return response.data;
	},

	async getById(id: string): Promise<Device> {
		const url = replaceParams(deviceEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<Device>>(url);
		return response.data.data;
	},

	async create(data: CreateDeviceRequest): Promise<Device> {
		const response = await apiClient.post<SuccessResponse<Device>>(deviceEndpoints.create, data);
		return response.data.data;
	},

	async update(id: string, data: UpdateDeviceRequest): Promise<Device> {
		const url = replaceParams(deviceEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<Device>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(deviceEndpoints.delete, { id });
		await apiClient.delete<SuccessResponse<MessageData>>(url);
	},

	/** RFC-009.3: Sync face enrollments to device */
	async sync(
		id: string,
		data?: { faceEnrollmentIds?: string[]; fullSync?: boolean }
	): Promise<{
		deviceId: string;
		syncJobId: string;
		status: string;
		totalEnrollments: number;
		syncedCount: number;
		failedCount: number;
		startedAt: string;
		completedAt?: string;
	}> {
		const url = replaceParams(deviceEndpoints.sync, { id });
		const response = await apiClient.post(url, data ?? {});
		return response.data.data;
	},
};
